import {NgModule} from '@angular/core';
import {RouterModule} from "@angular/router";
import {SharedModule} from "../../../shared.module";
import {ShareableComponent} from "./shareable.component";
import {ShareableCartComponent} from "./shareable-cart.component";
import {ProductResultsCardModule} from "../../product/results/product-results-card.module";
import {SocialWelcomeComponent} from "./welcome/social-welcome.component";
import {LocaleModule} from "../../locale/locale.module";

@NgModule({
    imports: [
        RouterModule,
        SharedModule,
        LocaleModule,
        ProductResultsCardModule
    ],
    declarations: [
        ShareableComponent,
        ShareableCartComponent,
        SocialWelcomeComponent
    ]
})
export class ShareableModule {}
